<template>
  <v-toolbar
    class="elevation-0"
    dark
    flat
  >
    <v-toolbar-title class="font-weight-light">
      <slot name="toolbar-title" />
    </v-toolbar-title>

    <v-spacer />

    <v-toolbar-items>
      <slot name="toolbar-icons" />
      <core-user-preferences />
    </v-toolbar-items>

    <template #extension>
      <slot name="extension" />
    </template>
  </v-toolbar>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  props: {
    tabs: Array,
  },

  data: () => ({
    langs: [
      'en', 'fr'
    ],
  }),

  asyncComputed: {
    isAdmin() {
      return this.isAdminAction();
    }
  },

  methods: {
    ...mapActions('auth', { isAdminAction: 'isAdmin' }),
    ...mapActions('app', [
      'toggleLocale'
    ]),
  }
};
</script>

<style scoped>
#core-toolbar a {
  text-decoration: none;
}
</style>
